import { render, staticRenderFns } from "./MSTeamsPresentButton.vue?vue&type=template&id=d0c79b3e"
import script from "./MSTeamsPresentButton.vue?vue&type=script&lang=js"
export * from "./MSTeamsPresentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports